<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "VoidFinancing"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/VoidFinancing.vue